/**
 * Created by Ning Jiang on 2/7/2018.
 */
/*Modified by Shikha*/

import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TimelineLite, Timeline, TweenLite, TimelineMax, Power4, Bounce, Animation} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {ImmortalFruitsGameConfig} from "../ImmortalFruitsGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {Container, Sprite, Graphics} from "pixi.js";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {bonusWheelEvents} from "../gameround/bonusWheelController";
import {ImmortalFruitsGameMode} from "../ImmortalFruitsGameMode";
import {ImmortalFruitsParsedGameData} from "../server/data/ImmortalFruitsParsedGameData";
import {ImmortalFruitsTextStyles} from "../config/ImmortalFruitsTextStyles";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {freezeLayers} from "../utils/freezeGame";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import { Emitter} from "pixi-particles";
import {ImmortalFruitsGameModuleConfig} from "../ImmortalFruitsGameModuleConfig";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {SoundManager} from "../resource/sound/SoundManager";
import {ImmortalFruitsSoundConfig} from "../ImmortalFruitsSoundConfig";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {ImmortalFruits} from "../ImmortalFruits";


export class BonusWheelView extends BaseView {

    private _layer: ScalableLayer;
    private _gameConfigInstance: ImmortalFruitsGameConfig = ImmortalFruitsGameConfig.instance;
    private _callBackCount: number;
    private _isQuickStop: boolean = false;
    private isWin: boolean = false;
    private _stoppingTl: TimelineLite | null;
    private _wheelSprite: Sprite[] = [];
    private borderWheel: Sprite[] = [];
    private JackpotStatic: Sprite;
    private _darkBg: Graphics;
    private maskCircle1: Graphics;
    private _rimSprite: Sprite;
    private _wheelShadow: Sprite;
    private pointerHighlight: TimelineSprite;
    private pointerBlueAnim: TimelineSprite;
    private lockLoop: TimelineSprite;
    private lockLoop1: TimelineSprite;
    private lockLoop2: TimelineSprite;
    private samePieLock1: TimelineSprite;
    private samePieLock2: TimelineSprite;
    private samePieLock: TimelineSprite;
    private samePieStroke: TimelineSprite;
    private samePieStroke1: TimelineSprite;
    private samePieStroke2: TimelineSprite;
    private redStroke: TimelineSprite[]=[];
    private jackpotText: TimelineSprite;
    private fireWork: TimelineSprite;
    private _center: Sprite;
    private _lvlUpSprite: Sprite[] = [];
    private _wheelContainer: PIXI.Container[] = [];
    private _wheelContainerBluePointerHighlight: PIXI.Container;
    private _pieContainers: any[] = [];
    private _pieSpriteContainers: PIXI.Container[] = [];
    private _mainWheelContainer: PIXI.Container;
    private _pieTextCont: PIXI.Container[] = [];
    private _pieTextCont2: PIXI.Container[] = [];
    private _pieTextCont3: PIXI.Container[] = [];
    private jackpotTextCont: PIXI.Container;
    private numOfPieces: number = 10;
    private _coord: number = 0;
    private _rotationFraction: number = 0;
    private _scatterPositions: number[];
    private wheelValues: number[][] = [[]];
    private _radienDistance: number[] = [254, 252, 245];
    private _pickedDistance: number[] = [283, 280, 290];
    private _jackpotIndicies: number = 7;
    private levelPositionsTakenAfter: boolean[] = [];
    private _index: number = 0;
    private landedIndex: number = -1;
    private totalWheelTimesBetCollectedAfter: number = -1;
    private alreadyAborted: boolean = false;
    private nextMode: string = "";
    private currentMode: string = "";
    private _betAccumulated: PIXI.BitmapText;
    private _scaleValues: number[][] = [[0.9, 0.71, 0.5],[0.9, .85, 0.55],[0.9, 0.86, 0.81]];
    private _scaleValuesAnim: number[][] = [[0.9, .9],[1.1, 1],  [1.1, 1.5]];
    private tween3: TweenLite;
    private startingOffset =(-1.5 * Math.PI * 2 / 10);// angle of one pie;
    private wheelYonResize = 0;
    private _betTextContainer: PIXI.Container;
    private _starParticleCont: PIXI.Container;
    private multiplierMeter: PIXI.spine.Spine;
    private multiplierMeter2: PIXI.spine.Spine;
    private bonusCricleAnim: PIXI.spine.Spine;
    private bonusSpinLightAnim: PIXI.spine.Spine;
    private bonusSpinLightRingAnim: PIXI.spine.Spine;
    private bonusOverJackpot: PIXI.spine.Spine;
    private bonusRaysJackpot: PIXI.spine.Spine;
    private bonusRadarAnim: PIXI.spine.Spine;
    private LevelupCon: PIXI.spine.Spine;
    private jackpotH: PIXI.spine.Spine;
    private jackpotH1: PIXI.spine.Spine;
    private bonusIntroCenter: PIXI.spine.Spine;
    private isPortrait: boolean = false;
    private innerWheelTl: TimelineMax | null;
    private initialSpinTl: TimelineMax | null;
    private isaLLSetup :boolean =false;
    private bWstrokeHalf:Sprite;
    private isRestoreState:boolean =false;
    private fireWorkSpriteArr:TimelineSprite[]=[];
    private _starEmitter: Emitter;
    private _starEmitterPortrait: Emitter;
    private jackPotAnimation :Animation;
    private pointerHighLightAnim :Animation;


    private readonly _starConfig: any = {
        "alpha": {
            "start": 1,
            "end": 0.8
        },
        "scale": {
            "start": 0.1,
            "end": 0.3,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 100,
            "end": 20,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 0,
            "max": 0
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": 0,
            "max": 0
        },
        "lifetime": {
            "min": 0.5,
            "max": 0.5
        },
        "blendMode": "add",
        "frequency": 0.01,
        "emitterLifetime": -1,
        "maxParticles": 50,
        "pos": {
            "x": this._gameConfigInstance.REEL_AREA_POS_X+150,
            "y" : ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT/2-80,
        },
        "addAtBack": true,
        "spawnType": "ring",
        "spawnCircle":
            {
                "x": this._gameConfigInstance.REEL_AREA_POS_X+150,
                "y": ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT/2-80,
                "r": 275,
                "minR":275
            },

    };
    private readonly _starConfigPortrait: any = {
        "alpha": {
            "start": 1,
            "end": 0.8
        },
        "scale": {
            "start": 0.1,
            "end": 0.3,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#ffffff",
            "end": "#ffffff"
        },
        "speed": {
            "start": 100,
            "end": 20,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 0
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 0,
            "max": 0
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": 0,
            "max": 0
        },
        "lifetime": {
            "min": 0.5,
            "max": 0.5
        },
        "blendMode": "add",
        "frequency": 0.01,
        "emitterLifetime": -1,
        "maxParticles": 50,
        "pos": {
            "x": this._gameConfigInstance.REEL_AREA_POS_X+150,
            "y" : ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT/2-80,
        },
        "addAtBack": true,
        "spawnType": "ring",
        "spawnCircle":
            {
                "x": this._gameConfigInstance.REEL_AREA_POS_X+150,
                "y": ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT/2-80-75,
                "r": 275,
                "minR":275
            },

    };
    constructor(index: number) {
        super();
        this._index = index;
        this._layer = StageManager.getLayer(this._gameConfigInstance.LAYERS.BONUS_WHEEL.name);
        this.addEventListeners();
    }

    private _velocity: number = 0;

    public get velocity(): number {
        return this._velocity;
    }

    public set velocity(val: number) {
        this._velocity = val;
    }

    public get coordRot(): number {
        return this._coord;
    }

    public get pieTextPieces(): PIXI.Container[] {
        return this._pieTextCont;
    }

    // 360/5 = 72 pieces of an circle;
    public static degreeToAngle(degree: number) {
        return BonusWheelView.normalizedRotation(360 / degree);
    }

    // 0|1 == 360.  2 = 180;
    public static normalizedRotation(rotation: number) {
        return (Math.PI * 2) / rotation;
    }

    public static frameToSeconds(val: number): number {
        return val / ImmortalFruitsGameConfig.instance.BROWSER_FPS;
    }

    public static DistanceByVTA(velocity: number, time: number, acceleration: number): number {
        return velocity * time + 0.5 * (acceleration * Math.pow(time, 2))
    }

    public static accCalcByVDT(velocity: number, distance: number, time: number): number {
        // return -velocity/time;
        return 2 * (distance - (velocity * time)) / Math.pow(time, 2)
    }

    public static accCalcByVVD(velocityTo: number, velocityFrom: number, distanceLeft: number): number {
        return (Math.pow(velocityTo, 2) - Math.pow(velocityFrom, 2)) / (distanceLeft * 2)
    }

    public static timeByVVA(velocityTo: number, velocityFrom: number, acceleration: number): number {
        return (velocityTo - velocityFrom) / acceleration
    }
    private getPointer(): TimelineSprite {
        const name: string = "wheelOfBonus/Pointer/pointer_",
            suffix: string = ".png";
        let textures: PIXI.Texture[] = [],
            timelineSpriteItem: TimelineSprite;
        for (let i: number = 0; i < 18; i++) {
            textures.push(ImgLoader.getImgTexture(name + i + suffix));
        }
        timelineSpriteItem = new TimelineSprite(textures);
        return timelineSpriteItem
    }
    public hideWheelContainer() {
        this._mainWheelContainer.visible = false;
        this._betTextContainer.visible = false;
        this._darkBg.visible = false;
    }

    public scatterPostion(data: any) {
        this._scatterPositions = data.scatterPositions;
        this.currentMode =data.mode;
        this.levelPositionsTakenAfter = data._levelPositionsTaken;
        this.wheelValues[0] = [0,3,5,1,10,3,5,100,1,25];
        this.wheelValues[1] = [0,3,30,3,15,5,15,250,5,25];
        this.wheelValues[2] = [50,5,100,5,20,5,25,2500,10,50];
        this.totalWheelTimesBetCollectedAfter = data.totalWheelTimesBetCollectedAfter;
        this._index = data.wheelLevel - 1;
        this.nextMode=data.nextMode;
        if (this._wheelSprite[0] && data.nextMode == ImmortalFruitsGameMode.BONUS_WHEEL && !this.isaLLSetup) {
            this.isaLLSetup = true;
            /* todo check why started here*/
            this._betTextContainer.visible = true;
            if(this.totalWheelTimesBetCollectedAfter>0){
                this._betAccumulated.text = "X" + this.totalWheelTimesBetCollectedAfter.toString();
                this._betAccumulated.x = -this._betAccumulated.width / 2;
            }
            this._wheelContainer[0].rotation = this.startingOffset;
            this._wheelContainerBluePointerHighlight.rotation = this.startingOffset;
            this._wheelContainer[1].rotation = this.startingOffset;
            this._wheelContainer[2].rotation = this.startingOffset;
            data.wheelLevel == 1 && this.resetWheelLevelOneUI();
            data.wheelLevel == 2 && this.resetSecondWheelLevelUI();
            data.wheelLevel == 3 && this.resetThirdWheelLevelUI();
        }

        if (this._wheelSprite[0]) {
            this.settingUPwheelNumbers(this.wheelValues[0], 0);
            this.settingUPwheelNumbers(this.wheelValues[1], 1);
            this.settingUPwheelNumbers(this.wheelValues[2], 2);
            this._wheelContainer[0].rotation = this.startingOffset;
            this._wheelContainer[1].rotation = this.startingOffset;
            this._wheelContainer[2].rotation = this.startingOffset;
        }
        this.isRestoreState =data.isRestoreState;
    }

    public onGameDataParsed(data: ImmortalFruitsParsedGameData) {
        this.currentMode = data.mode;
        this.multiplierMeter2.renderable = false;
        this.bonusRaysJackpot.renderable = false;
        this.bonusRaysJackpot.state.clearTrack(0);
        this._starEmitter.emit =false;
        this._starEmitterPortrait.emit =false;
        this.alreadyAborted = false;
        this.nextMode = data.nextMode;
        this.wheelValues[0] = [0,3,5,1,10,3,5,100,1,25];
        this.wheelValues[1] = [0,3,30,3,15,5,15,250,5,25];
        this.wheelValues[2] = [50,5,100,5,20,5,25,2500,10,50];
        this.levelPositionsTakenAfter = data.levelPositionsTakenAfter;
        this.totalWheelTimesBetCollectedAfter = data.totalWheelTimesBetCollectedAfter;

        this.landedIndex = data.LandedWheelIndex;
        this._index = data.wheelLevel - 1;
        if (data.mode === ImmortalFruitsGameMode.NORMAL || data.mode === ImmortalFruitsGameMode.GAMBLE && data!.nextMode === ImmortalFruitsGameMode.BONUS_WHEEL) {
            this.settingUPwheelNumbers(this.wheelValues[0], 0);
            this.settingUPwheelNumbers(this.wheelValues[1], 1);
            this.settingUPwheelNumbers(this.wheelValues[2], 2);
            this._wheelContainer[0].rotation = this.startingOffset;
            this._wheelContainer[1].rotation = this.startingOffset;
            this._wheelContainer[2].rotation = this.startingOffset;
            data.wheelLevel == 1 && this.resetWheelLevelOneUI();
            data.wheelLevel == 2 && this.resetSecondWheelLevelUI();
            data.wheelLevel == 3 && this.resetThirdWheelLevelUI();

        }
        this.isRestoreState =false;
        if (this.initialSpinTl) {
            this.initialSpinTl!.pause();
            this.initialSpinTl!.clear();
            this.initialSpinTl!.kill();
        }
        this.initialSpinTl = this.timeLineNuller(this.initialSpinTl);
    }

    public settingUPwheelNumbers(arr: number[], index: number) {
        // if(this.isRestoreState){
        //     /**
        //      * 188
        //      */
        //     ImmortalFruitsGameModuleConfig.symWinAnims.noWinSymbols();
        // }
        this.numOfPieces = arr.length;
        this._coord = BonusWheelView.normalizedRotation(this.numOfPieces);
        let highestValue: number = 0;
        for (let v = 0; v < arr.length; v++)
            if (arr[v] > highestValue)
                highestValue = arr[v];
        for (let k = 0; k < arr.length; k++) {
            let distant = this._radienDistance[index];
            let arrValueLength: number = arr[k].toString().length + 1;
            if (arr[k] == 0) arrValueLength--;

            let cont: PIXI.Container = this._pieContainers[index][k];

            let offSinglePos2 = -1.09 + 0.62 * 0.5;
            let rot = (this._coord * k) + offSinglePos2;

            if (cont.children.length > 0)
                cont.removeChildren();
            let text = new PIXI.BitmapText("X" + arr[k].toString(), ImmortalFruitsTextStyles.WHEEL_COUNTUP);
            text.alpha=1;
            //text.tint =;
            let offSinglePos = -1.0 + 0.62 * 0.5;
            let offSetRot = 0.13;
            /* levelUpSprite */

            if (arr[k] == 0 && index !== 2) {
                this._lvlUpSprite[index].rotation = 0.65 + 0.62 * 0.5;// rot + BonusWheelView.normalizedRotation(4);
                this._lvlUpSprite[index].position = this.rotPos(rot, distant + 5);
                this._lvlUpSprite[index].visible = true;
                this._lvlUpSprite[index].alpha = 1;
                this._lvlUpSprite[index].scale.set(0.26);
                if(index==1){
                    this._lvlUpSprite[index].position = this.rotPos(rot, distant -5);
                }
            }
            for (let l = 0; l < arrValueLength - 1; l++) {
                text.pivot.set(0.5);
                let offSinglePos2 = offSinglePos * 0.5 + (offSinglePos / (arrValueLength - 1)) * l - .07;
                rot = (this._coord * k) + (arrValueLength !== 1 && arrValueLength < 3 ? offSinglePos : offSinglePos2);
                text.scale.set(0.65);
                if (arr[k] !== 0) {
                    if (arrValueLength !== 1) {

                            text.position = this.rotPos(rot, distant);

                        text.rotation = rot + BonusWheelView.normalizedRotation(4) + 0.16;
                        if (k == 7 && index == 0) {
                            text.position = this.rotPos(rot + 0.12, distant);
                            text.rotation = rot + BonusWheelView.normalizedRotation(4) + 0.25;
                        }
                        if(k==9 && index == 0){
                            text.position = this.rotPos(rot + 0.02, distant);
                        }
                        if(k==4 && index == 0){
                            text.position = this.rotPos(rot + 0.06, distant);
                        }
                        if (k === 7 && index == 1) {
                            text.position = this.rotPos(rot + 0.08, distant);
                            text.rotation = rot + BonusWheelView.normalizedRotation(4) + 0.25
                        }
                        if (k === 7 && (index == 2)) {

                            text.position = this.rotPos(rot + 0.08, distant);
                            text.rotation = rot + BonusWheelView.normalizedRotation(4) + 0.3;

                        }
                        if(k==2 && (index == 2)){
                            text.position = this.rotPos(rot + 0.10, distant);
                            text.rotation = rot + BonusWheelView.normalizedRotation(4) + 0.3;
                        }
                        cont.addChild(text);
                        if (index == 1 || index == 2) {
                            text.scale.set(0.95);
                        }


                    }
                }
            }
            //Removed this individual character adjustment since later versions of pixi does not make sprites of each letter, instead it's all rendered on a mesh. So this type of adjustment isn't possible in this way.
            //The wheel is slightly uglier now. But this is a very minor detail overall.
  /*          if (index == 0) {
                text.getChildAt(0)!.rotation =-0.1;
                text.getChildAt(0)!.x = 2;
                text.getChildAt(0)!.y = -2;

                text.getChildAt(1)!.y = -2;
                text.getChildAt(1)!.x = 29;

                if (text.children.length == 3) {
                    //text.x =52;
                    text.getChildAt(0)!.rotation = 0;
                    text.getChildAt(0)!.x = 2;

                    text.getChildAt(1)!.rotation = 0;
                    text.getChildAt(1)!.y = 0;
                    text.getChildAt(1)!.x = 26;

                    text.getChildAt(2)!.x = 52;
                    text.getChildAt(2)!.rotation = 0.05;
                    text.getChildAt(2)!.y = 1;
                    if(k==4){
                        text.getChildAt(0)!.rotation = -0.05;
                        text.getChildAt(0)!.x = 2;

                        text.getChildAt(1)!.rotation = 0.02;
                        text.getChildAt(1)!.y = 0;
                        text.getChildAt(1)!.x = 23;

                        text.getChildAt(2)!.x = 46;
                        text.getChildAt(2)!.rotation = 0;
                        text.getChildAt(2)!.y = 1;
                    }
                }
                if (text.children.length == 4) {
                    text.getChildAt(0)!.rotation = -0.05;
                    text.getChildAt(0)!.x = 5;

                    text.getChildAt(1)!.rotation = -0.05;
                    text.getChildAt(1)!.y = 0;
                    text.getChildAt(1)!.x = 23;

                    text.getChildAt(2)!.x = 49;
                    text.getChildAt(2)!.rotation = 0.01;
                    text.getChildAt(2)!.y = -1;

                    text.getChildAt(3)!.x = 75;
                    text.getChildAt(3)!.rotation = 0.05;
                    text.getChildAt(3)!.y = 0;
                }
            }
            if (index == 1 || index == 2) {
                text.getChildAt(0)!.rotation = -0.1;
                text.getChildAt(0)!.x = -2;
                text.getChildAt(1)!.x = 22;
                if (text.children.length == 3) {
                    if (text.getChildAt(2)) {
                        text.getChildAt(2)!.x = 46;
                        text.getChildAt(2)!.rotation = 0.05;
                        text.getChildAt(2)!.y = 1;
                    }
                }
                if (text.children.length == 4) {
                    text.getChildAt(0)!.rotation = 0;
                    text.getChildAt(0)!.x = -2;
                    text.getChildAt(0)!.y = 1;

                    text.getChildAt(1)!.rotation = 0;
                    text.getChildAt(1)!.y = 0;
                    text.getChildAt(1)!.x = 21;

                    text.getChildAt(2)!.x = 45;
                    text.getChildAt(2)!.rotation = 0.05;
                    text.getChildAt(2)!.y = 0;

                    text.getChildAt(3)!.x = 69;
                    text.getChildAt(3)!.y = 1;
                    text.getChildAt(3)!.rotation = 0.1;

                }
                if (text.children.length == 5) {
                    text.getChildAt(0)!.rotation = -0.1;
                    text.getChildAt(0)!.x = 0;
                    text.getChildAt(0)!.y = 2;

                    text.getChildAt(1)!.rotation = 0;
                    text.getChildAt(1)!.y = 0;
                    text.getChildAt(1)!.x = 22.5;

                    text.getChildAt(2)!.x = 46;
                    text.getChildAt(2)!.y = 0;
                    text.getChildAt(2)!.rotation = 0.05;

                    text.getChildAt(3)!.x = 70;
                    text.getChildAt(3)!.y = 0;
                    text.getChildAt(3)!.rotation = 0.1;

                    text.getChildAt(4)!.rotation = 0.1;
                    text.getChildAt(4)!.y = 2;
                    text.getChildAt(4)!.x = 92;
                }
            }
            if(index==2){
                if (text.children.length == 4) {
                    text.getChildAt(0)!.rotation = -0.1;
                    text.getChildAt(0)!.x = -2;
                    text.getChildAt(0)!.y = 0;

                    text.getChildAt(1)!.rotation = -.05;
                    text.getChildAt(1)!.y = 0;
                    text.getChildAt(1)!.x = 13;

                    text.getChildAt(2)!.x = 35;
                    text.getChildAt(2)!.rotation = 0;
                    text.getChildAt(2)!.y = -2;

                    text.getChildAt(3)!.x = 57;
                    text.getChildAt(3)!.y = -1;
                    text.getChildAt(3)!.rotation = 0;
                }
                if(k==8){
                    text.getChildAt(0)!.rotation = -0.05;
                    text.getChildAt(0)!.x = 1;
                    text.getChildAt(1)!.x = 16;
                    if (text.children.length == 3) {
                        if (text.getChildAt(2)) {
                            text.getChildAt(2)!.x = 39;
                            text.getChildAt(2)!.rotation = 0.05;
                            text.getChildAt(2)!.y = 1;
                        }
                    }
                }
            }

            */
            this._wheelContainer[index].addChild(cont);
            this._wheelContainer[index].addChild(this._pieSpriteContainers[index]);
            this._pieContainers[index][k] = cont;
        }
    }
    private playInnerWheelTl(){
        this.innerWheelTl = this.timeLineNuller(this.innerWheelTl);

        this.innerWheelTl = new TimelineMax({
            repeat: -1,
            repeatDelay: 0,
        });
        this.innerWheelTl.to(this._wheelContainer[this._index], 1, {
            onUpdate: () => {
                    if (this._index + 2 === 2) {
                        this._wheelContainer[this._index + 2].rotation = this._wheelContainer[this._index + 2].rotation % BonusWheelView.normalizedRotation(1);
                        this._wheelContainer[this._index + 2].rotation -= 0.002;
                    }
                    if (this._index + 1 > 0 && this._index !== 2) {
                        this._wheelContainer[this._index + 1].rotation = this._wheelContainer[this._index + 1].rotation % BonusWheelView.normalizedRotation(1);
                        this._wheelContainer[this._index + 1].rotation -= 0.001;
                    }
                }
        });
    }
    private initialSpinBeforeResponseRecieved(){
        this.initialSpinTl = this.timeLineNuller(this.initialSpinTl);

        this.initialSpinTl = new TimelineMax({
            repeat: -1,
            repeatDelay: 0,
        });
        this.initialSpinTl.to(this._wheelContainer[this._index], 0.4, {
            onUpdate: () => {
                    this._wheelContainer[this._index].rotation = this._wheelContainer[this._index].rotation % BonusWheelView.normalizedRotation(1);
                    this._wheelContainer[this._index].rotation += 0.05;

            }
        });
    }
    public startPresentation() {
           //to reset pies
        this.alreadyAborted = false;
        if (this.alreadyAborted) {
            return;
        }
        this.jackpotH.renderable = false;
        this.jackpotH1.renderable = false;

        this.jackpotH1.state.clearTrack(0);
        this.jackpotH.state.clearTrack(0);
        this._darkBg.visible = true;
        this._mainWheelContainer.visible = true;

        let spineTl = new TimelineLite({
            onComplete: () => {
                spineTl.kill();
                spineTl.clear();
            }
        });
        let playSpine: TimelineLite;
        let playSpine3: TimelineLite;
        playSpine = new SpineTween(this.bonusCricleAnim, 0, "bw_ww_spin_light_animation", 0);
        playSpine3 = new SpineTween(this.bonusSpinLightRingAnim, 0, "bw_bw_spin_light_animation", 0);
        let playSpineDuration = playSpine.totalDuration();
        let playSpine3Duration = playSpine3.totalDuration();

        spineTl.add(() => {
            new TweenLite(this._wheelShadow, 0.5, {alpha: 1});
            this.resetAllBonusContainers();
            SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELGLOW,undefined,1);

            this.maskCircle1.visible = true;
            this.bonusCricleAnim.renderable = true;
            this.bonusSpinLightAnim.scale.set(0.95);
            this.bonusSpinLightRingAnim.scale.set(0.95);
            this.bonusCricleAnim.state.setAnimation(0,"bw_ww_spin_light_animation",false);

        }, 0);
        spineTl.add(()=>{
            if (!this.alreadyAborted) {
                this.bonusSpinLightAnim.renderable = true;
                this.bonusSpinLightAnim.state.setAnimation(0, "bw_rw_spin_light_animation", false);
                this.bonusSpinLightRingAnim.renderable = true;
                this.bonusSpinLightRingAnim.state.setAnimation(0, "bw_bw_spin_light_animation", false);
                SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELSPIN,undefined,1);


                TweenLite.to(this._wheelContainer[this._index], playSpine3Duration, {
                    rotation: this._wheelContainer[this._index].rotation - 0.3, onComplete: () => {
                        if (this.alreadyAborted) {
                            this._wheelContainer[this._index].rotation = Math.abs((this.numOfPieces - (this.landedIndex)) * this.coordRot) - 2 * Math.PI / 10 * 1.5;
                        }
                    }
                });
            }else{
                SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELGLOW);
            }
        },playSpineDuration);
        spineTl.add(() => {
            this.bonusCricleAnim.renderable = false;
            this.maskCircle1.visible = false;
            this.bonusSpinLightAnim.renderable = false;
            this.bonusSpinLightRingAnim.renderable = false;


            if (!this.alreadyAborted) {
                this.bonusRadarAnim.renderable = true;
                this.bonusRadarAnim.state.setAnimation(0,"bw_radar_spin_animation",false);
                this.bonusSpinLightAnim.renderable = true;
                this.bonusSpinLightRingAnim.renderable = true;

                this.bonusSpinLightAnim.scale.set(this._scaleValuesAnim[this._index][0]);
                this.bonusSpinLightRingAnim.scale.set(this._scaleValuesAnim[this._index][1]);

                this._mainWheelContainer.addChildAt(this.bonusSpinLightAnim,this._mainWheelContainer.getChildIndex(this.borderWheel[1])+1);
                this._mainWheelContainer.addChildAt(this.bonusSpinLightRingAnim,this._mainWheelContainer.getChildIndex(this.borderWheel[2])+1);

                new SpineTween(this.bonusSpinLightAnim, 0, "bw_ring_loop_animation", -1);
                new SpineTween(this.bonusSpinLightRingAnim, 0, "rw_ring_loop_animation", -1);
                this.bonusOverJackpot.renderable = true;
                new SpineTween(this.bonusOverJackpot, 0, "bw_light_loop_animation", -1);

            }else{
                SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELGLOW);
            }
        }, playSpineDuration+playSpine3Duration);
    }
    public startSpinning(){
        this.stopInnerWheelTl();
        this.playInnerWheelTl();
        if (this.initialSpinTl) {
            this.initialSpinTl!.pause();
            this.initialSpinTl!.clear();
            this.initialSpinTl!.kill();
        }
        this.initialSpinTl = this.timeLineNuller(this.initialSpinTl);
        if (this.alreadyAborted) {
            return;
        }

        EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.STOP_WHEEL, this.landedIndex, 0, 1));
    }

    public secondsToFrame(val: number): number {
        return val * ImmortalFruitsGameConfig.instance.BROWSER_FPS;
    }

    public resetCallbackCount(count: number): void {
        this._callBackCount = count;
        this._isQuickStop = false;
        this._stoppingTl && this._stoppingTl.clear();
    }

    public currentPiece(): number {
        let len: number = this.numOfPieces;
        let posT = (len - Math.floor(((this.pieRotDistance() / this.coordRot)) % len)) % len;
        return posT;
    }

    public pieRotDistance(): number {
        let rott = this._wheelContainer[this._index].rotation + (this.coordRot * .5);
        return rott;
    }

    public stopEngine(hitPos: number, toVel: number = 0, rotTimes: number = 2) {
        let p: number = Math.abs((this.numOfPieces - (hitPos)) * this.coordRot);
        p += BonusWheelView.normalizedRotation(1) - 2 * Math.PI / 10 * 1.5;
        this.changeSpeed(p, toVel, false);

    }

    public changeSpeed(distance: number, toVel: number = 0, ongoing: boolean = false) {
        this.velocity = 0.08;
        if (this._stoppingTl) {
            this._stoppingTl.pause();
            this._stoppingTl.clear();
            this._stoppingTl.kill();
        }
        this._stoppingTl = this.timeLineNuller(this._stoppingTl);
        this.tween3 && this.tween3.kill();
        //0.31 == halfofPIe
        let calcTease1: number = Math.random() * (-0.31 + 0.1) - 0.1;
        let calcTease2: number = Math.random() * (0.31 - 0.1) + 0.1;
        let calcTease = Math.random() < 0.5 ? calcTease1 : calcTease2;

        distance += ongoing ? this._wheelContainer[this._index].rotation : calcTease;
        this._wheelContainer[this._index].rotation = this._wheelContainer[this._index].rotation % BonusWheelView.normalizedRotation(1);
        let startPos = this._wheelContainer[this._index].rotation;
        let fTRot: number = distance - this._wheelContainer[this._index].rotation;
        let vel: number = this.velocity / (BonusWheelView.frameToSeconds(2) / 4);
        fTRot = fTRot % BonusWheelView.normalizedRotation(1) + 2 * BonusWheelView.normalizedRotation(1);
        let velChange: number = vel * toVel;

        let accByDist = BonusWheelView.accCalcByVVD(velChange, vel, fTRot);
        let timeByAcc = BonusWheelView.timeByVVA(velChange, vel, accByDist);
        let center: number = distance - calcTease;


        this._stoppingTl = new TimelineLite();

        if (!this.alreadyAborted) {
            this._stoppingTl.to(this._wheelContainer[this._index], timeByAcc, {
                onUpdate: () => {
                    if (!this.alreadyAborted) {
                        this._wheelContainer[this._index].rotation = startPos + BonusWheelView.DistanceByVTA(vel, this._stoppingTl!.progress() * timeByAcc, accByDist);
                        // SoundTick
                        if (this._rotationFraction > this._wheelContainer[this._index].rotation % BonusWheelView.normalizedRotation(30))
                            this._rotationFraction = this._wheelContainer[this._index].rotation % BonusWheelView.normalizedRotation(30);
                        this._wheelContainer[this._index].rotation = this._wheelContainer[this._index].rotation % BonusWheelView.normalizedRotation(1);
                    }
                }
                , ease: Power4.easeInOut
            });

            this._stoppingTl.add(() => {
                if (!this.alreadyAborted) {
                    let finalCenter = center % BonusWheelView.normalizedRotation(1);
                    let finalR = this._wheelContainer[this._index].rotation - finalCenter;
                    let notRequiredToMove = Number(this._wheelContainer[this._index].rotation.toFixed(2)) === 0
                    if (!notRequiredToMove) {
                        this.tween3 = TweenLite.to(this._wheelContainer[this._index], 0.5, {
                            rotation: finalCenter, ease: Bounce.easeOut, onComplete: () => {
                            }
                        })
                    }
                }

            }, timeByAcc + 0.2);
            this._stoppingTl.play();

            let delay = timeByAcc-1;
            EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.NOTIFY_FINISH, delay));

        }


        //}

    }

    public timeLineNuller(timeline: Timeline | TimelineLite | TimelineMax | null): null {
        if (!timeline) return null;
        let tLiteMax = timeline as TimelineLite | TimelineMax;

        if (tLiteMax) {
            tLiteMax.pause();
            tLiteMax.clear();
            tLiteMax.kill();
        } else {
            timeline.pause();
            timeline.kill();
        }
        return null;
    }

    public checkScatterWinCount(scatterPositions: number[]): boolean {
        let count = 0;
        scatterPositions!.map((value) => {
            value > -1 && count++;
        });
        if (count > 2) {
            this.isWin = true;
        }
        return this.isWin;
    }

    public onResize(bounds: any): void {

        this._betAccumulated.pivot.set(0.5);
        this._darkBg.clear();
        this._darkBg.beginFill(0x000000, 0.63);
        this._darkBg.pivot.set(0, 0.5);
        this._mainWheelContainer.position.x = this._gameConfigInstance.REEL_AREA_POS_X + this._gameConfigInstance.SYMBOL_WIDTH * 2.5 + 5;
        freezeLayers.onResize(this._layer); //#175 #178 fixed
        this.wheelYonResize = this._gameConfigInstance.REEL_AREA_POS_Y + this._gameConfigInstance.SYMBOL_HEIGHT * 2 ;
        this._mainWheelContainer.position.y = this.wheelYonResize;
        if ("portrait" == bounds.orientation) {
            this.jackpotTextCont.scale.set(0.75);
            this.isPortrait = true;
            this.jackpotH1.x = this._gameConfigInstance.REEL_AREA_POS_X + this._gameConfigInstance.SYMBOL_WIDTH * 2.5 + 5;
            this.jackpotH1.y = this._gameConfigInstance.REEL_AREA_POS_Y + this._gameConfigInstance.SYMBOL_WIDTH * 1.5+5;
            this.LevelupCon.x = this._gameConfigInstance.REEL_AREA_POS_X + this._gameConfigInstance.SYMBOL_WIDTH * 2.5 + 5;
            this.LevelupCon.y = this._gameConfigInstance.REEL_AREA_POS_Y + this._gameConfigInstance.SYMBOL_WIDTH * 1.5+5;
            this.wheelYonResize =  this._gameConfigInstance.SYMBOL_HEIGHT * 2.5 -25 ;
            this.multiplierMeter2.y = 26;
            this._mainWheelContainer.position.set(this._gameConfigInstance.REEL_AREA_POS_X + this._gameConfigInstance.SYMBOL_WIDTH * 2.5 + 5, this.wheelYonResize);
            this._betAccumulated.position.set(-65, 0);
            this._betTextContainer.position.set((bounds.width) * 0.5, this._gameConfigInstance.REEL_AREA_POS_Y - 1.3 * this._gameConfigInstance.SYMBOL_HEIGHT);
            //this._darkBg.drawRect(ImmortalFruitsGameConfig.instance.REEL_AREA_POS_X-9 + 13, ImmortalFruitsGameConfig.instance.PORTRAIT_OFFSET, ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH * 0.9 - 3, ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT + 5);

        } else {
            this.jackpotTextCont.scale.set(1);
            this.isPortrait = false;
            this.jackpotH1.x = this._gameConfigInstance.REEL_AREA_POS_X + this._gameConfigInstance.SYMBOL_WIDTH * 2.5 + 5;
            this.jackpotH1.y = this._gameConfigInstance.REEL_AREA_POS_Y + this._gameConfigInstance.SYMBOL_WIDTH * 2 +19;
            this.multiplierMeter2.y = 26;
            this._betAccumulated.position.set(-68, 0);
            this._betTextContainer.position.set((bounds.width) * 0.625, Helper.getSymbolPositions(4, 0)[1]);
            //this._darkBg.drawRect(ImmortalFruitsGameConfig.instance.REEL_AREA_POS_X-9+13, ImmortalFruitsGameConfig.instance.REEL_AREA_POS_Y+3, ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH*0.9 -3, ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT+5);
            this._mainWheelContainer.position.y = this.wheelYonResize;

        }
        this.LevelupCon.x = 2;
        this.LevelupCon.y = -24;
        this._betAccumulated.x = -this._betAccumulated.width / 2;
        this._darkBg.drawRect(-450, -450, bounds.width + 450, bounds.height + 450);
        this.jackpotH.position = this.jackpotH1.position;
        this.bonusIntroCenter.position = this.jackpotH1.position;


    };
    /*
      * to Handle abort
      * */
    public abortStoppingTL() {
        this.alreadyAborted = true;
        SoundManager.stopSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELSPIN);
        if (this.tween3 && this.tween3.totalProgress() < 1) {
            this.tween3.totalProgress(1);
        }
        if (this._stoppingTl) {
            this._stoppingTl.getChildren().forEach((child) => {
                if (child.timeline.totalProgress() < 1) {
                    child.timeline.totalProgress(1);
                }
            });
            if (this._stoppingTl.totalProgress() < 1) {
                this._stoppingTl.totalProgress(1);
                this._stoppingTl.pause();
                this._stoppingTl = this.timeLineNuller(this._stoppingTl);
            }
        }
        this._wheelContainer[this._index].rotation = Math.abs((this.numOfPieces - (this.landedIndex)) * this.coordRot) - 2 * Math.PI / 10 * 1.5;
    }

    protected addEventListeners() {
        EventHandler.addEventListener(this, bonusWheelEvents.STOP_WHEEL, (event: GameEvent) => this.stopEngine(event.params[0], event.params[1], event.params[2]));
        EventHandler.addEventListener(this, bonusWheelEvents.ABORT_SPINNING, (event: GameEvent) => this.abortStoppingTL());
        EventHandler.addEventListener(this, bonusWheelEvents.SHOW_WHEEL_ANIMATION, (event: GameEvent) => this.showWheelAnimation());
        EventHandler.addEventListener(this, bonusWheelEvents.HIDE_WHEELS, (event: GameEvent) => this.hideWheelAnimation());
        EventHandler.addEventListener(this, bonusWheelEvents.START_BIGWIN, (event: GameEvent) => this.hideDarkBG());
        EventHandler.addEventListener(this, bonusWheelEvents.STOP_BIGWIN, (event: GameEvent) => this.showDarkBG());
        EventHandler.addEventListener(this, bonusWheelEvents.HIGHLIGHT_ONABORT, (event: GameEvent) => this.startSelection());
        EventHandler.addEventListener(this, bonusWheelEvents.ABORT_ANIMATIONS, (event: GameEvent) => this.abortWPresentation());
        EventHandler.addEventListener(this, bonusWheelEvents.BEGIN_ANIMATING, (event: GameEvent) => this.startPresentation());
        EventHandler.addEventListener(this, bonusWheelEvents.BEGIN_SPIN, (event: GameEvent) => this.initialSpinBeforeResponseRecieved());
        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => this.onReady());
    }
    private onReady(){
        if(this.isRestoreState){
            /**
             * 188
             */
            ImmortalFruitsGameModuleConfig.symWinAnims.noWinSymbols();
        }
    }
    protected initAnimations(): void {
        this.jackpotH = new PIXI.spine.Spine(GameResources.getSpineAsset("mini_jackpot_hit_new"));
        this.jackpotH1 = new PIXI.spine.Spine(GameResources.getSpineAsset("mini_jackpot_hit_new"));
        this.bonusIntroCenter = new PIXI.spine.Spine(GameResources.getSpineAsset("mini_jackpot_hit"));

        this._mainWheelContainer = new PIXI.Container();
        this.jackpotTextCont = new PIXI.Container();
        this._starParticleCont = new PIXI.Container();
        this._darkBg = new Graphics();
        this._darkBg.name = "_darkBg";
        this._darkBg.beginFill(0x000000, 0.63);
        this._darkBg.visible = false;
        this._mainWheelContainer.name = "mainWheelContainer";
        this._wheelContainer[0] = new PIXI.Container();
        this._wheelContainer[1] = new PIXI.Container();
        this._wheelContainer[2] = new PIXI.Container();
        this._wheelContainerBluePointerHighlight = new PIXI.Container();
        this._betTextContainer = new PIXI.Container();
        this._wheelSprite[0] = new Sprite(GameResources.getTextures("wheel1")[0]);
        this._wheelShadow = new Sprite(GameResources.getTextures("wheelShadow")[0]);
        this.borderWheel[0] = new Sprite(GameResources.getTextures("borderWheel1")[0]);
        this._rimSprite = new Sprite(GameResources.getTextures("rimWheel")[0]);
        this._wheelSprite[1] = new Sprite(GameResources.getTextures("wheel2")[0]);
        this.borderWheel[1] = new Sprite(GameResources.getTextures("borderWheel2")[0]);
        this._wheelSprite[2] = new Sprite(GameResources.getTextures("wheel3")[0]);
        this.borderWheel[2] = new Sprite(GameResources.getTextures("borderWheel3")[0]);
        this.pointerHighlight = this.getPointer();//new TimelineSprite(GameResources.getTextures("pointerHighlight"));
        this.lockLoop = new TimelineSprite(GameResources.getTextures("lockLoop"));
        this.lockLoop1 = new TimelineSprite(GameResources.getTextures("lockLoop1"));
        this.lockLoop2 = new TimelineSprite(GameResources.getTextures("lockLoop2"));
        this.samePieLock = new TimelineSprite(GameResources.getTextures("samePieLock"));
        this.samePieLock1 = new TimelineSprite(GameResources.getTextures("samePieLock1"));
        this.samePieLock2 = new TimelineSprite(GameResources.getTextures("samePieLock2"));
        this.samePieStroke = new TimelineSprite(GameResources.getTextures("samePieStroke"));
        this.samePieStroke1 = new TimelineSprite(GameResources.getTextures("bluePieStroke"));
        this.samePieStroke2 = new TimelineSprite(GameResources.getTextures("redPieStroke"));
        this.pointerBlueAnim = new TimelineSprite(GameResources.getTextures("pointerStopAnim"), 19);
        this._center = new Sprite(GameResources.getTextures("center")[0]);
        this._lvlUpSprite.push(new Sprite(GameResources.getTextures("LevelUp")[0]));
        this._lvlUpSprite.push(new Sprite(GameResources.getTextures("LevelUp")[0]));
        this._lvlUpSprite[0].scale.set(0.3);
        this._lvlUpSprite[1].scale.set(0.3);
        this._rimSprite.scale.set(0.91);
        this.pointerHighlight.anchor.set(0.5);
        this.pointerBlueAnim.anchor.set(0.5);
        this.pointerBlueAnim.scale.set(1.1, 1);
        this._rimSprite.anchor.set(0.5);
        this._wheelShadow.anchor.set(0.5);
        this._wheelShadow.alpha = 0;
        this._center.anchor.set(0.5);
        //this._mainWheelContainer.position.set(this._gameConfigInstance.REEL_AREA_POS_X-9 + Helper.getSymbolPositions(1, 1)[0], this._gameConfigInstance.REEL_AREA_POS_Y + this._gameConfigInstance.SYMBOL_HEIGHT * 2.5);
        this._betAccumulated = new PIXI.BitmapText("", ImmortalFruitsTextStyles.FS_OUTRO_COUNT_UP);
        this._layer.addChild(this._darkBg);

        this.bonusCricleAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("BonusWheelOverlay"));
        this.bonusSpinLightAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("BonusWheelOverlay"));
        this.bonusSpinLightRingAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("BonusWheelOverlay"));
        this.bonusRadarAnim = new PIXI.spine.Spine(GameResources.getSpineAsset("BonusWheelOverlay"));
        this.bonusOverJackpot = new PIXI.spine.Spine(GameResources.getSpineAsset("BonusWheelOverlay"));
        this.bonusRaysJackpot = new PIXI.spine.Spine(GameResources.getSpineAsset("BonusWheelOverlay"));

        this.LevelupCon = new PIXI.spine.Spine(GameResources.getSpineAsset("Levelup"));
        this.multiplierMeter = new PIXI.spine.Spine(GameResources.getSpineAsset("jackpotMeter"));
        this.multiplierMeter2 = new PIXI.spine.Spine(GameResources.getSpineAsset("jackpotMeter"));
        this._betTextContainer.addChild(this.multiplierMeter);
        this._betTextContainer.addChild(this.multiplierMeter2);
        this._betTextContainer.addChild(this._betAccumulated);
        this._layer.addChild(this._betTextContainer);


        this.hideWheelContainer();
        this.addSlices();


        this.jackpotH.pivot.set(0.5);
        this.jackpotH1.pivot.set(0.5);

        this.bonusIntroCenter.pivot.set(0.5);

        this.bonusCricleAnim.pivot.set(0.5);
        this.bonusSpinLightRingAnim.pivot.set(0.5);
        this.bonusRadarAnim.pivot.set(0.5);
        this.bonusOverJackpot.pivot.set(0.5);
        this.LevelupCon.pivot.set(0.5);
        this.bonusRaysJackpot.pivot.set(0.5);
        this.multiplierMeter.pivot.set(0.5);
        this.multiplierMeter2.pivot.set(0.5);

        this.jackpotH.renderable = false;
        this.jackpotH1.renderable = false;
        this.bonusIntroCenter.renderable = false;
        this.multiplierMeter2.renderable = false;
        this.pointerBlueAnim.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._layer.addChild(this._starParticleCont);
        this.resetAllBonusContainers();
        this._pieSpriteContainers[0] = new PIXI.Container();
        this._pieSpriteContainers[1] = new PIXI.Container();
        this._pieSpriteContainers[2] = new PIXI.Container();
        this._wheelContainer[0].addChild(this._pieSpriteContainers[0]);
        this._wheelContainer[1].addChild(this._pieSpriteContainers[1]);
        this._wheelContainer[2].addChild(this._pieSpriteContainers[2]);
        this.setUpWheels();//this.nextMode == ImmortalFruitsGameMode.BONUS_WHEEL
        if ((this.currentMode == ImmortalFruitsGameMode.BONUS_WHEEL && this.nextMode !== ImmortalFruitsGameMode.GAMBLE  ) && !this.isaLLSetup || this.nextMode == ImmortalFruitsGameMode.BONUS_WHEEL) {
            this.isaLLSetup = true;
            if(this.totalWheelTimesBetCollectedAfter>0){
                this._betAccumulated.text = "X" + this.totalWheelTimesBetCollectedAfter.toString();
                this._betAccumulated.x = -this._betAccumulated.width / 2;
            }
            this.settingUPwheelNumbers(this.wheelValues[0], 0);
            this.settingUPwheelNumbers(this.wheelValues[1], 1);
            this.settingUPwheelNumbers(this.wheelValues[2], 2);
            this._index == 0 && this.resetWheelLevelOneUI();
            this._index == 1 && this.resetSecondWheelLevelUI();
            this._index == 2 && this.resetThirdWheelLevelUI();
            if(this.isRestoreState && this.currentMode!==ImmortalFruitsGameMode.NORMAL && this.currentMode!==ImmortalFruitsGameMode.GAMBLE) {
                this._darkBg.visible =true;
                this._mainWheelContainer.visible =true};
        }
        this._wheelContainerBluePointerHighlight.addChild(this.pointerBlueAnim);

        this.bonusRadarAnim.scale.set(0.95);
        this.bonusCricleAnim.scale.set(0.95);
        this.bonusSpinLightAnim.scale.set(0.95);
        this.bonusSpinLightRingAnim.scale.set(0.95);
        this.bonusRaysJackpot.scale.set(0.91);
        this.bonusOverJackpot.scale.set(0.91);

        this._rimSprite.rotation = this.startingOffset;
        this.bonusRadarAnim.rotation = this.startingOffset + 0.62;
        this.bonusOverJackpot.rotation = this.startingOffset;
        this._wheelShadow.scale.set(0.91);


        this.multiplierMeter.state.setAnimation(0,"jp_meter_normal",false);

        this._coord = BonusWheelView.normalizedRotation(this.numOfPieces);
        this.createPieSpriteContainers(0);
        this.createPieSpriteContainers(1);
        this.createPieSpriteContainers(2);
        this.setPickedPiesOnRestore();


        this._wheelContainerBluePointerHighlight.addChild(this.lockLoop);
        this._wheelContainerBluePointerHighlight.addChild(this.lockLoop1);
        this._wheelContainerBluePointerHighlight.addChild(this.lockLoop2);
        this._wheelContainerBluePointerHighlight.addChild(this.samePieLock);
        this._wheelContainerBluePointerHighlight.addChild(this.samePieLock1);
        this._wheelContainerBluePointerHighlight.addChild(this.samePieLock2);
        this._wheelContainerBluePointerHighlight.addChild(this.samePieStroke);
        this._wheelContainerBluePointerHighlight.addChild(this.samePieStroke1);
        this._wheelContainerBluePointerHighlight.addChild(this.samePieStroke2);
        this.lockLoop.anchor.set(0.5);
        this.lockLoop1.anchor.set(0.5);
        this.lockLoop2.anchor.set(0.5);
        this.samePieLock.anchor.set(0.5);
        this.samePieLock1.anchor.set(0.5);
        this.samePieLock2.anchor.set(0.5);
        this.samePieStroke.anchor.set(0.5);
        this.samePieStroke1.anchor.set(0.5);
        this.samePieStroke2.anchor.set(0.5);
        this.samePieStroke.scale.set(2);
        this.samePieStroke1.scale.set(2);
        this.lockLoop.visible =false;
        this.lockLoop2.visible =false;
        this.lockLoop1.visible =false;
        this.samePieLock.visible =false;
        this.samePieLock1.visible =false;
        this.samePieLock2.visible =false;
        this.samePieStroke.visible =false;
        this.samePieStroke2.visible =false;
        this.jackpotText = new TimelineSprite(GameResources.getTextures("jackpotText"));
        this.JackpotStatic = new Sprite(GameResources.getTextures("JackpotStatic")[0]);
        this.fireWork = new TimelineSprite(GameResources.getTextures("fireWork"));
        this.fireWork.blendMode =PIXI.BLEND_MODES.ADD;
        this._wheelContainerBluePointerHighlight.addChild(this.fireWork);

        this.fireWork.name ="fireWork";
        this.jackpotText.visible = false;
        this.JackpotStatic.visible = false;
        this.jackpotText.visible = false;
        this.jackpotTextCont.addChild(this.jackpotText);
        this.jackpotTextCont.addChild(this.JackpotStatic);
        this._mainWheelContainer.addChildAt(this.jackpotTextCont,this._mainWheelContainer.getChildIndex(this._center)+1);
        this.fireWork.visible = false;
        this.jackpotText.anchor.set(0.5);
        this.JackpotStatic.anchor.set(0.5);
        this.fireWork.anchor.set(0.5);
        this.jackpotText.scale.set(1.7);
        this.samePieStroke1.blendMode =PIXI.BLEND_MODES.ADD;
        this.samePieStroke2.blendMode =PIXI.BLEND_MODES.ADD;
    }
    /*
     * level up animation
     * */
    private playLevelUpAnimation(){
        //this._mainWheelContainer.addChild(this.back_Overlay);
        this._mainWheelContainer.addChild(this.bWstrokeHalf);

        this.bonusOverJackpot.renderable = false;
        this.jackpotH.renderable = false;
        this.bonusIntroCenter.renderable = false;
        new SpineTween(this.bonusOverJackpot, 0, "bw_light_jp_hit_animation" ,-1);
        let tl = new TimelineLite();
        this._mainWheelContainer.addChild(this.LevelupCon);
        let anim=  new SpineTween(this.LevelupCon, 0, "level_up" ,0);
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEEL_LEVELUP,undefined,1);
        tl.add(()=>{
            this.bonusOverJackpot.renderable = true;
            TweenLite.to(this.bWstrokeHalf,0.266,{alpha:1});
        },0);
        tl.add(()=>{
            // this.back_Overlay.getAnimation();
            // this.back_Overlay.visible =true;
        },0.46);
        tl.add(()=>{
            TweenLite.to(this.bonusOverJackpot,0.36,{alpha:0});
        },0.9);
        tl.add(()=>{
             this.bWstrokeHalf.alpha =0;
             this.bonusOverJackpot.renderable =false;
             this.bonusOverJackpot.alpha =1;
             //this.back_Overlay.visible =false;
             this.bWstrokeHalf.alpha =0;
            this._index+1  == 1 && this.secondLevel();
            this._index+1  == 2 && this.thirdLevel();
            this.levelUpWheelAnimation(this._index+1);
        },anim.totalDuration());
    }
    /*
    * to hide  dark background
   * */
    private hideDarkBG() {
        this._darkBg.clear();
        this._darkBg.beginFill(0x000000, 0.63);
        this._darkBg.pivot.set(0, 0.5);
        if (this.isPortrait) {
            this._darkBg.drawRect(ImmortalFruitsGameConfig.instance.REEL_AREA_POS_X -3, ImmortalFruitsGameConfig.instance.PORTRAIT_OFFSET-8, ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH * 0.91+2, ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT + 8);

        } else {
            this._darkBg.drawRect(ImmortalFruitsGameConfig.instance.REEL_AREA_POS_X -2 , ImmortalFruitsGameConfig.instance.REEL_AREA_POS_Y -2,
                ImmortalFruitsGameConfig.instance.REEL_AREA_WIDTH*0.91+2  , ImmortalFruitsGameConfig.instance.REEL_AREA_HEIGHT+4 );

        }

    }
    /*
     * to show Wheel dark background layer during bonus
    * */
    private showDarkBG() {
        this._darkBg.clear();
        this._darkBg.beginFill(0x000000, 0.63);
        this._darkBg.pivot.set(0, 0.5);
        this._darkBg.drawRect(-450, -450, NolimitApplication.screenBounds.width + 450, NolimitApplication.screenBounds.height + 450);
    }
    /*
    * to hide Wheel Animation at the end of bonus
    * */
    private hideWheelAnimation() {
        TweenLite.to(this._mainWheelContainer,0.2,{alpha:0});
        TweenLite.to(this._mainWheelContainer.scale,0.5,{x:0.2,y:0.2,onComplete:()=>{
                this._mainWheelContainer.visible=false;
                this._mainWheelContainer.alpha=1;
                this._mainWheelContainer.scale.set(1);
        }});
        this._darkBg.visible = false;

        this._betAccumulated.text = "";
        this._betTextContainer.visible = false;
        if(this.lockLoop){
            this.lockLoop.stopLoop();
            this.lockLoop.hide();
        }
        this._starEmitter.emit =false;
        this._starEmitterPortrait.emit =false;
        this.bonusOverJackpot.alpha = 1;
        this.jackpotH1.alpha = 1;
        this.bonusOverJackpot.renderable = false;
        this.jackpotH1.renderable = false;
        this.jackpotH1.state.clearTrack(0);
        this.bonusOverJackpot.state.clearTrack(0);
        this.redStroke.forEach((redStrokeAnim)=>{
            redStrokeAnim.stopLoop();
            redStrokeAnim.visible = false;
        });
        this.lockLoop2.visible =false;
        this.lockLoop.visible =false;
        this.lockLoop1.visible =false;
        this.samePieStroke2.visible =false;
        this.samePieStroke.visible =false;
        this.samePieStroke1.visible =false;
        this.samePieLock1.visible =false;
        this.samePieLock2.visible =false;
        this.samePieLock.visible =false;
        EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.HIDE_JACKPOTWON));
    }

    private showWheelAnimation() {
        this.bonusSpinLightAnim.renderable = false;
        this._wheelShadow.alpha = 0;
        let startOff = 0.5;
        let startOff1 = 0.15;
        this._rimSprite.scale.set(0);
        this._darkBg.visible = true;
        this.pointerHighlight.alpha = 0;
        this._center.alpha = 0;
        this._betTextContainer.alpha = 0;
        this._mainWheelContainer.visible = true;
        this._mainWheelContainer.y = this.wheelYonResize;
        this._mainWheelContainer.pivot.set(0.5);

        let tl = new TimelineLite();
        this._wheelContainer[0].scale.set(0);
        this.borderWheel[0].scale.set(0);
        this.borderWheel[1].scale.set(0);
        this._wheelContainer[1].scale.set(0);
        this._wheelContainer[2].scale.set(0);
        this.borderWheel[2].scale.set(0);




        tl.add(() => {
            SoundManager.playBonusIntroWheel();
            TweenLite.fromTo(this._rimSprite.scale, 0.2, {x: 0, y: 0}, {x: 1.1, y: 1.1});
        }, startOff);
        tl.add(() => {
            TweenLite.fromTo(this._rimSprite.scale, 0.3, {x: 1, y: 1}, {x: 0.91, y: 0.91});
        }, startOff + 0.2);
        tl.add(() => {
            TweenLite.fromTo(this.borderWheel[0].scale, 0.2, {x: 0, y: 0}, {x: 0.96, y: 0.96});
            TweenLite.fromTo(this._wheelContainer[0].scale, 0.2, {x: 0, y: 0}, {x: 0.96, y: 0.96});
        }, startOff + startOff1);
        tl.add(() => {
            this.jackpotH1.renderable = true;
            new SpineTween(this.jackpotH1, 0, "mini_jp_hit_center_animation");
        }, startOff + 0.23);
        tl.add(() => {
            TweenLite.fromTo(this.borderWheel[0].scale, 0.3, {x: 0.96, y: 0.96}, {
                x: this._scaleValues[0][0] + 0.01,
                y: this._scaleValues[0][0] + 0.01
            });
            TweenLite.fromTo(this._wheelContainer[0].scale, 0.3, {x: 0.96, y: 0.96}, {x: 0.91, y: 0.91});
        }, startOff + startOff1 + 0.2);

        tl.add(() => {
            // this.bonusOverJackpot.renderable = true;
            // new SpineTween(this.bonusOverJackpot, 0, "bw_light_jp_hit_animation" );
            this._center.alpha = 1;
            TweenLite.fromTo(this._center.scale, 0.7, {x: 0, y: 0}, {x: 0.7, y: 0.7});
            TweenLite.fromTo(this.borderWheel[1].scale, 0.2, {x: 0, y: 0}, {
                x: this._scaleValues[0][1] + 0.2,
                y: this._scaleValues[0][1] + 0.2
            });
            TweenLite.fromTo(this._wheelContainer[1].scale, 0.2, {x: 0, y: 0}, {
                x: this._scaleValues[0][1] + 0.2,
                y: this._scaleValues[0][1] + 0.2
            });
        }, startOff + 2 * startOff1);
        tl.add(() => {
            TweenLite.fromTo(this.borderWheel[1].scale, 0.3, {
                x: this._scaleValues[0][1] + 0.2,
                y: this._scaleValues[0][1] + 0.2
            }, {x: this._scaleValues[0][1], y: this._scaleValues[0][1]});
            TweenLite.fromTo(this._wheelContainer[1].scale, 0.3, {
                x: this._scaleValues[0][1] + 0.2,
                y: this._scaleValues[0][1] + 0.2
            }, {x: this._scaleValues[0][1], y: this._scaleValues[0][1]});
        }, startOff + 2 * startOff1 + 0.2);
        tl.add(() => {
            this.bonusIntroCenter.scale.set(0.65);
            this.bonusIntroCenter.renderable = true;
            new SpineTween(this.bonusIntroCenter, 0, "bw_transition_animation", 0);
        }, startOff + 0.33);
        tl.add(() => {

            TweenLite.fromTo(this.borderWheel[2].scale, 0.2, {x: 0.2, y: 0.2}, {
                x: this._scaleValues[0][2] + 0.1,
                y: this._scaleValues[0][2] + 0.1
            });
            TweenLite.fromTo(this._wheelContainer[2].scale, 0.2, {x: 0.2, y: 0.2}, {
                x: this._scaleValues[0][2] + 0.1,
                y: this._scaleValues[0][2] + 0.1
            });
        }, startOff + 3 * startOff1);


        tl.add(() => {
            this.bonusOverJackpot.renderable = true;
            new SpineTween(this.bonusOverJackpot, 0, "bw_light_jp_hit_animation");
            TweenLite.fromTo(this.borderWheel[2].scale, 0.3, {
                x: this._scaleValues[0][2] + 0.1,
                y: this._scaleValues[0][2] + 0.1
            }, {x: this._scaleValues[0][2], y: this._scaleValues[0][2]});
            TweenLite.fromTo(this._wheelContainer[2].scale, 0.3, {
                x: this._scaleValues[0][2] + 0.1,
                y: this._scaleValues[0][2] + 0.1
            }, {x: this._scaleValues[0][2], y: this._scaleValues[0][2]});
        }, startOff + 3 * startOff1 + 0.2);
        tl.add(() => {
            this.borderWheel[2].scale.set(this._scaleValues[0][2]);
            TweenLite.to(this.pointerHighlight, 0.2, {alpha: 1});
            TweenLite.to(this._betTextContainer, 0.2, {alpha: 1});
            this.multiplierMeter.state.setAnimation(0, "jp_meter_normal", false);

            this.pointerHighlight.visible = true;
            this._betTextContainer.visible = true;
            this.bonusIntroCenter.renderable = false;
            this.jackpotH1.renderable = false;
            this.bonusOverJackpot.renderable = false;
            this.showDarkBG();

        }, startOff + 3 * startOff1 + 0.6);
        this._betAccumulated.text = "";

        this._pieSpriteContainers[0].children.forEach((sprite) => {

            if (sprite.name && sprite.name!.indexOf("pickedArr1") !== -1) {
                sprite.visible = false;
            }

        });
        this._pieSpriteContainers[1].children.forEach((sprite) => {
            if (sprite.name && sprite.name!.indexOf("pickedArr2") !== -1) {
                sprite.visible = false;
            }
        });
        this._pieSpriteContainers[2].children.forEach((sprite) => {
            if (sprite.name && sprite.name!.indexOf("pickedArr2") !== -1) {
                sprite.visible = false;
            }

        });
    }

    private resetAllBonusContainers() {
        if (!this.maskCircle1) {
            this.maskCircle1 = new Graphics();
            this.maskCircle1.beginFill(0x644A50, 1);
            this.maskCircle1.visible = false;
            this.maskCircle1.pivot.set(0.5);
            this.maskCircle1.drawCircle(0, 0, this._wheelSprite[0].height / 2 * 0.9);
            this.bonusCricleAnim.addChild(this.maskCircle1);
        }
        this._mainWheelContainer.addChild(this.bonusRaysJackpot);
        this.bonusRaysJackpot.name="raysJackpot";
        this._layer.addChild(this.jackpotH);
        this._layer.addChild(this.bonusIntroCenter);
        this._starParticleCont.name ="starParticleCont";
        this._starEmitter =new Emitter(this._starParticleCont, [GameResources.getTextures("star")[0]], this._starConfig);
        this._starEmitterPortrait =new Emitter(this._starParticleCont, [GameResources.getTextures("star")[0]], this._starConfigPortrait);
        ParticlesManager.addEmitter(this._starEmitter, false);
        ParticlesManager.addEmitter(this._starEmitterPortrait, false);
        this._wheelShadow.name = "_wheelShadow";
        this._mainWheelContainer.addChild(this._wheelShadow);
        this._mainWheelContainer.addChild(this._rimSprite);
        this._layer.addChild(this._mainWheelContainer);
        this._layer.addChild(this.jackpotH1);



        this._mainWheelContainer.addChild(this._wheelContainer[0]);
        this._mainWheelContainer.addChild(this._wheelContainerBluePointerHighlight);
        this._mainWheelContainer.addChild(this._wheelContainer[1]);
        this._mainWheelContainer.addChild(this._wheelContainer[2]);
        this._mainWheelContainer.addChild(this.bonusCricleAnim);
        this._mainWheelContainer.addChild(this.borderWheel[1]);
        this._mainWheelContainer.addChild(this.borderWheel[0]);
        this._mainWheelContainer.addChild(this.borderWheel[2]);

        this._mainWheelContainer.addChild(this.bonusSpinLightRingAnim);
        this._mainWheelContainer.addChild(this.bonusSpinLightAnim);
        this._mainWheelContainer.addChild(this.bonusOverJackpot);
        this._mainWheelContainer.addChild(this.bonusRadarAnim);


        this.bonusCricleAnim.renderable = false;
        this.bonusSpinLightRingAnim.renderable = false;
        this.bonusSpinLightAnim.renderable = false;
        this.bonusOverJackpot.renderable = false;
        this.bonusRadarAnim.renderable = false;
        this.bonusRaysJackpot.renderable = false;
        this.bonusIntroCenter.renderable = false;
        this.bWstrokeHalf = new Sprite(GameResources.getTextures("bWstrokeHalf")[0]);
        this._mainWheelContainer.addChild(this.bWstrokeHalf);
        this.bWstrokeHalf.scale.set(1.85);
        this.bWstrokeHalf.y =-19;
        this.bWstrokeHalf.anchor.set(0.5);
        this.bWstrokeHalf.alpha =0;
        //this.back_Overlay = new TimelineSprite(GameResources.getTextures("back_Overlay"));
        //this._mainWheelContainer.addChild(this.back_Overlay);
       // this._mainWheelContainer.addChild(this._arrow);
        this._mainWheelContainer.addChild(this.pointerHighlight);
        this._mainWheelContainer.addChild(this._center);
        this.bonusCricleAnim.mask = this.maskCircle1;
    }

    private setUpWheels() {
        this._wheelContainer[0].name = "wheelContainer1";
        this._wheelContainer[1].name = "wheelContainer2";
        this._wheelContainer[2].name = "wheelContainer3";
        this._wheelContainer[0].addChild(this._wheelSprite[0]);
        this._wheelContainer[1].addChild(this._wheelSprite[1]);
        this._wheelContainer[2].addChild(this._wheelSprite[2]);
        this._wheelContainer[0].addChild(this._lvlUpSprite[0]);
        this._wheelContainer[1].addChild(this._lvlUpSprite[1]);
        this._wheelSprite[0].anchor.set(0.5);
        this._wheelSprite[1].anchor.set(0.5);
        this._wheelSprite[2].anchor.set(0.5);
        this.borderWheel[0].anchor.set(0.5);
        this.borderWheel[1].anchor.set(0.5);
        this.borderWheel[2].anchor.set(0.5);
        this._wheelContainerBluePointerHighlight.addChild(this.pointerBlueAnim);
        this._wheelContainerBluePointerHighlight.name ="POINTER BLUE WHEEL"


        this.lockLoop2.visible =false;
        this.lockLoop1.visible =false;
        this.samePieStroke2.visible =false;
        this.samePieStroke1.visible =false;
        this.samePieLock1.visible =false;
        this.samePieLock2.visible =false;
    }
    private levelUpWheelAnimation(levelIndex:number){
        let tl = new TimelineLite();
        let startOff =0.5;//pause between two animations;
        let startOff1 =0.15;

        tl.add(() => {
            this.jackpotH1.renderable = true;
            new SpineTween(this.jackpotH1, 0, "mini_jp_hit_center_animation");
        }, startOff + 0.23);
        tl.add(() => {
            SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELGLOW_LEVEL_UP,undefined,1);
            TweenLite.fromTo(this.borderWheel[1].scale, 0.2, {x: this._scaleValues[levelIndex-1][1], y: this._scaleValues[levelIndex-1][1]}, {
                x: this._scaleValues[levelIndex][1] + 0.05,
                y: this._scaleValues[levelIndex][1] + 0.05
            });
            TweenLite.fromTo(this._wheelContainer[1].scale, 0.2, {x: this._scaleValues[levelIndex-1][1], y: this._scaleValues[levelIndex-1][1]}, {
                x: this._scaleValues[levelIndex][1] + 0.05,
                y: this._scaleValues[levelIndex][1] + 0.05
            });
        }, startOff + 2 * startOff1);
        tl.add(() => {
            TweenLite.fromTo(this.borderWheel[1].scale, 0.3, {
                x: this._scaleValues[levelIndex][1] + 0.05,
                y: this._scaleValues[levelIndex][1] + 0.05
            }, {x: this._scaleValues[levelIndex][1]+0.01, y: this._scaleValues[levelIndex][1]+0.01});
            TweenLite.fromTo(this._wheelContainer[1].scale, 0.3, {
                x: this._scaleValues[levelIndex][1] + 0.1,
                y: this._scaleValues[levelIndex][1] + 0.1
            }, {x: this._scaleValues[levelIndex][1], y: this._scaleValues[levelIndex][1]});
        }, startOff + 2 * startOff1 + 0.2);
        tl.add(() => {
            this.bonusIntroCenter.scale.set(0.65);
            this.bonusIntroCenter.renderable = true;
            new SpineTween(this.bonusIntroCenter, 0, "bw_transition_animation", 0);
        }, startOff + 0.33);
        tl.add(() => {
            TweenLite.fromTo(this.borderWheel[2].scale, 0.2, {x: this._scaleValues[levelIndex-1][1], y: this._scaleValues[levelIndex-1][1]}, {
                x: this._scaleValues[levelIndex][2] + 0.07,
                y: this._scaleValues[levelIndex][2] + 0.07
            });
            TweenLite.fromTo(this._wheelContainer[2].scale, 0.2, {x:this._scaleValues[levelIndex-1][1], y:this._scaleValues[levelIndex-1][1]}, {
                x: this._scaleValues[levelIndex][2]+0.07 ,
                y: this._scaleValues[levelIndex][2]+0.07
            });
        }, startOff + 3 * startOff1);


        tl.add(() => {
            this.bonusOverJackpot.renderable = true;
            new SpineTween(this.bonusOverJackpot, 0, "bw_light_jp_hit_animation");
            TweenLite.fromTo(this.borderWheel[2].scale, 0.3, {
                x: this._scaleValues[levelIndex][2] + 0.07,
                y: this._scaleValues[levelIndex][2] + 0.07
            }, {x: this._scaleValues[levelIndex][2], y: this._scaleValues[levelIndex][2]});
            TweenLite.fromTo(this._wheelContainer[2].scale, 0.3, {
                x: this._scaleValues[levelIndex][2] + 0.07,
                y: this._scaleValues[levelIndex][2] + 0.07
            }, {x: this._scaleValues[levelIndex][2], y: this._scaleValues[levelIndex][2]});
        }, startOff + 3 * startOff1 + 0.2);
    }
    private resetSecondWheelLevelUI() {
        this.resetWheelLevelOneUI();
        this._wheelContainer[0].scale.set(this._scaleValues[1][0]);
        this._wheelContainer[1].scale.set(this._scaleValues[1][1]);
        this._wheelContainer[2].scale.set(this._scaleValues[1][2]);
        this.borderWheel[0].scale.set(this._scaleValues[1][0] + 0.01);
        this.borderWheel[1].scale.set(this._scaleValues[1][1] + 0.01);
        this.borderWheel[2].scale.set(this._scaleValues[1][2]);
       this.secondLevel();
    }
    private secondLevel(){
        this._wheelContainer[0].scale.set(this._scaleValues[1][0]);
        this.borderWheel[0].scale.set(this._scaleValues[1][0] + 0.01);
        this._wheelContainerBluePointerHighlight.scale.set(this._scaleValues[1][1]);
        this._mainWheelContainer.addChildAt(this._wheelContainerBluePointerHighlight, this._mainWheelContainer.getChildIndex(this._wheelContainer[1])+1);
        this._wheelContainer[0].pivot.set(0, 0);
        this._wheelContainer[1].pivot.set(0, 0);
        this._wheelContainer[2].pivot.set(0, 0);
        this._mainWheelContainer.addChildAt(this.borderWheel[0], this._mainWheelContainer.getChildIndex(this.borderWheel[1])+1);
        this.pointerBlueAnim.y=-219;
        this.pointerBlueAnim.scale.set(1,1.1);
        this._mainWheelContainer.addChildAt(this._wheelContainerBluePointerHighlight, this._mainWheelContainer.getChildIndex(this._wheelContainer[1])+1);
        this.samePieLock1.y =-190;
        this.lockLoop1.y =-215;
        this.samePieStroke1.y =-205;

        this.samePieStroke1.alpha =0.5;

        this.lockLoop1.scale.set(1.15,1.17);
        this.samePieLock1.scale.set(1.15,1.17);


        this.lockLoop.visible =false;
        this.lockLoop2.visible =false;
        this.samePieStroke.visible =false;
        this.samePieStroke2.visible =false;
        this.samePieLock.visible =false;
        this.samePieLock2.visible =false;
    }
    private thirdLevel(){
        this._wheelContainer[0].scale.set(this._scaleValues[2][0]);
        this.borderWheel[0].scale.set(this._scaleValues[2][0] + 0.01);
        this._wheelContainerBluePointerHighlight.scale.set(this._scaleValues[2][2]);
        this._mainWheelContainer.addChildAt(this._wheelContainerBluePointerHighlight, this._mainWheelContainer.getChildIndex(this._wheelContainer[2])+1);
        this._wheelContainer[0].pivot.set(0, 0);
        this._wheelContainer[1].pivot.set(0, 0);
        this._wheelContainer[2].pivot.set(0, 0);
        this._mainWheelContainer.addChildAt(this.borderWheel[1], this._mainWheelContainer.getChildIndex(this.borderWheel[0])+1);
        this.pointerBlueAnim.y=-219;
        this.pointerBlueAnim.x=-2;
        this.pointerBlueAnim.scale.set(1.1);
        this.samePieLock2.y =-206;
        this.lockLoop2.y =-215;
        this.lockLoop2.x =-2;
        this.samePieStroke2.y =-194;

        this.samePieStroke2.alpha =0.5;
        this.samePieStroke2.x =6;
        this.samePieStroke2.scale.set(2.3);
        this.lockLoop2.scale.set(1.15,1.17);
        this.samePieLock2.scale.set(1.15);



        this.lockLoop.visible =false;
        this.lockLoop1.visible =false;
        this.samePieStroke.visible =false;
        this.samePieStroke1.visible =false;
        this.samePieLock.visible =false;
        this.samePieLock1.visible =false;

        this.setUPRedWheelAnimation();
        if(this.fireWork){
            this.fireWork.position = this.pointerBlueAnim.position;
        }

    }
    private resetThirdWheelLevelUI() {
        this.resetWheelLevelOneUI();
        this._wheelContainer[0].scale.set(this._scaleValues[2][0]);
        this._wheelContainer[1].scale.set(this._scaleValues[2][1]);
        this._wheelContainer[2].scale.set(this._scaleValues[2][2]);
        this.borderWheel[0].scale.set(this._scaleValues[2][0] + 0.01);
        this.borderWheel[1].scale.set(this._scaleValues[2][1]);
        this.borderWheel[2].scale.set(this._scaleValues[2][2]);
        this.thirdLevel();
    }
    private setUPRedWheelAnimation(){

        for(let i=0;i<10;i++){
            let pickedPierot = Math.round((this._coord * (i + 1) + Number.EPSILON) * 100) / 100 - 1 - 0.59;
            this.redStroke.push(new TimelineSprite(GameResources.getTextures("redStroke"))) ;
            //this.redStroke[i].position.set(0,0);
            this.redStroke[i].anchor.set(0);
            this._wheelContainer[2].addChild(this.redStroke[i]);
            this.redStroke[i].rotation = Math.round((this._coord * (i + 1) + Number.EPSILON) * 100) / 100 ;
            //this.redStroke[.scale.set(1.02, 1);
            this.redStroke[i].position = this.rotPos(pickedPierot -0.05, this._pickedDistance[2] +4);
            this.redStroke[i].blendMode =PIXI.BLEND_MODES.ADD;
            //this.redStroke[i].playLoop();
            this.redStroke[i].scale.y =1.5;
            this.redStroke[i].x +=3;
            if(i==0){
                this.redStroke[i].x +=3;
            }
            if(i==1){
                this.redStroke[i].x +=6;
            }
            if(i==2){
                this.redStroke[i].x -=15;
            }
            if(i>2 && i<5){
                this.redStroke[i].x -=10;
            }
            if(i==7){
                this.redStroke[i].x +=12;
            }
            if(i==5){
                this.redStroke[i].x -=12;
            }
            if(i==8){
                this.redStroke[i].x +=4;
            }
            if(i===6){
                this.redStroke[i].x -=25;
            }

        }

    }

    private resetWheelLevelOneUI() {
        this._rimSprite.visible = true;
        this._center.visible = true;
        this._rimSprite.pivot.set(0.5);
        this._wheelContainer[0].pivot.set(0.5);
        this._wheelContainer[1].pivot.set(0.5);
        this._wheelContainer[2].pivot.set(0.5);
        this._wheelContainer[0].scale.set(this._scaleValues[0][0]);
        this._wheelContainer[1].scale.set(this._scaleValues[0][1]);
        this._wheelContainer[2].scale.set(this._scaleValues[0][2]);
        this.borderWheel[0].scale.set(this._scaleValues[0][0] + 0.01);
        this.borderWheel[1].scale.set(this._scaleValues[0][1]);
        this.borderWheel[2].scale.set(this._scaleValues[0][2]);
        this._wheelContainerBluePointerHighlight.scale.set(this._scaleValues[0][0]);
        this._wheelContainer[0].rotation = this.startingOffset;
        this._wheelContainer[1].rotation = this.startingOffset;
        this._wheelContainer[2].rotation = this.startingOffset;
        this.pointerHighlight.y = -this._gameConfigInstance.SYMBOL_HEIGHT * 1.8 - 30;
        this.pointerBlueAnim.y = -this._gameConfigInstance.SYMBOL_HEIGHT * 1.65;
        this.pointerHighlight.x = 0;
       // this.pointerHighlight.scale.set(0.65,0.6);
        this._center.scale.set(0.7);
        this._center.rotation = -0.7;
        this._mainWheelContainer.addChildAt(this._wheelContainerBluePointerHighlight, this._mainWheelContainer.getChildIndex(this._wheelContainer[0])+1);
        this._wheelContainer[0].pivot.set(0, 0);
        this._wheelContainer[1].pivot.set(0, 0);
        this._wheelContainer[2].pivot.set(0, 0);
        //this.pointerHighlight.blendMode = PIXI.BLEND_MODES.ADD;
        this._mainWheelContainer.addChildAt(this.borderWheel[0], this._mainWheelContainer.getChildIndex(this.borderWheel[1])+1)
        this.pointerBlueAnim.scale.set(1.1,1);

        this.samePieStroke.scale.set(2);
        this.lockLoop.visible =false;
        this.samePieLock.visible =false;
        this.samePieStroke.visible =false;
        this.lockLoop.y =-233;
        this.samePieLock.y =-206;
        this.samePieStroke.y =-206;
        this.samePieStroke.blendMode =PIXI.BLEND_MODES.ADD;
    }

    private abortWPresentation() {

    }

    private calculateWinPTime() {
        let playWPDuration = 1;
        if (this.landedIndex == this._jackpotIndicies) {
            const playWP = new SpineTween(this.jackpotH, 0, "mini_jp_hit_animation", 1);
            playWPDuration = playWP.totalDuration();
       //  if(this._index==2){
             playWPDuration+=2.5;
         //}
        } else if(this.landedIndex==0 && (this._index==0||this._index==1)){
            //console.log("levelUp Animation")
            playWPDuration = 3;
        }else if(this.isSamePieHit(this.landedIndex)){
            //console.log("same pie Animation")
            playWPDuration = this.samePieStroke.totalDuration+this.samePieLock.totalDuration+1;
        }else{
            //console.log("normal Animation")
            playWPDuration =1
        }

        let duration = this.pointerHighlight.totalDuration + this.pointerBlueAnim.totalDuration + playWPDuration;
        return duration;
    }
    private stopInnerWheelTl(){
        //to reset pies

        if (this.innerWheelTl) {
            this.innerWheelTl!.pause();
            this.innerWheelTl!.clear();
            this.innerWheelTl!.kill();
        }
        this.innerWheelTl = this.timeLineNuller(this.innerWheelTl);
    }
    private onCompleteArrowHighLight(spineJackpotAnim:TimelineLite){
        let startingOff = 0.8;
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELLOCK,undefined,1);
        if(this.isSamePieHit(this.landedIndex)){


            spineJackpotAnim.add(() => {
                SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELFIRE,undefined,1);
                if(this._index==1){
                    this.samePieStroke1.show();
                    this.samePieStroke1.getAnimation();
                }else if(this._index==2){
                    this.samePieStroke2.show();
                    this.samePieStroke2.getAnimation();
                }else{
                    this.samePieStroke.show();
                    this.samePieStroke.getAnimation();
                }

            },startingOff);
            spineJackpotAnim.add(() => {
                if(this._index==1){
                    this.samePieLock1.show();
                    this.samePieLock1.getAnimation([0],()=>{},()=>{
                        this.lockLoop1.show();
                        this.samePieLock1.hide();
                        this.samePieStroke1.hide();
                        this.lockLoop1.playLoop();
                    });
                }else if(this._index==2){
                    this.samePieLock2.show();
                    this.samePieLock2.getAnimation([0],()=>{},()=>{
                        this.lockLoop2.show();
                        this.samePieLock2.hide();
                        this.samePieStroke2.hide();
                        this.lockLoop2.playLoop();
                    });
                }else{
                    this.samePieLock.show();
                    this.samePieLock.getAnimation([0],()=>{},()=>{
                        this.lockLoop.show();
                        this.samePieLock.hide();
                        this.samePieStroke.hide();
                        this.lockLoop.playLoop();
                    });
                }

            },this.samePieLock.totalDuration*0.65+startingOff)
        }else {
            this._mainWheelContainer.addChildAt(this.jackpotTextCont,this._mainWheelContainer.getChildIndex(this._center)+1);
            if (this.landedIndex === 0 && this._index !== 2) {
                SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELLHITUP,undefined,1);
            }else if(this.wheelValues[this._index][this.landedIndex] >=50 ) {
                SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELLHITBIG,undefined,1);
            }else{
                SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELLHITONCE,undefined,1);
            }
            spineJackpotAnim.add(() => {
                this.pointerBlueAnim.getAnimation([0], () => {
                }, () => {


                });
            },startingOff);
            spineJackpotAnim.add(() => {
                if(this.landedIndex == this._jackpotIndicies){
                    this.fireWork.show();
                    this.fireWork.getAnimation();
                 // EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.SHOW_JACKPOTWON));
                }
                this.playWPresentation();
            },startingOff+this.pointerBlueAnim.totalDuration/2);
        }

    }
    private startSelection() {

        // if( this.alreadyAborted){
        //     startingOff =0;
        // }

        let spineJackpotAnim = new TimelineLite();
        EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.NOTIFY_WP_FINISH, this.calculateWinPTime()-0.5));

        spineJackpotAnim.add(() => {
            if (this.nextMode === ImmortalFruitsGameMode.GAMBLE|| this.nextMode === ImmortalFruitsGameMode.NORMAL) {
               this.stopInnerWheelTl();
            }

        }, this.calculateWinPTime()-0.5);

        this.bonusSpinLightRingAnim.renderable = false;
        this.bonusOverJackpot.renderable = false;
        this.bonusSpinLightAnim.renderable = false;
        this.bonusRadarAnim.renderable = false;
        this.bonusSpinLightRingAnim.state.clearTracks();
        this.bonusOverJackpot.state.clearTrack(0);
        this.bonusRadarAnim.state.clearTrack(0);
        //not show presentation if no is repeated
        this._mainWheelContainer.addChildAt(this._wheelContainerBluePointerHighlight, this._mainWheelContainer.getChildIndex(this._wheelContainer[this._index])+1);
             this.pointerHighLightAnim  = this.pointerHighlight.getAnimation([0], () => {
            }, () => {
                this.onCompleteArrowHighLight(spineJackpotAnim);
             });
        if( this.alreadyAborted){
            this.pointerHighLightAnim.totalProgress(0.8);
        }else{
            this.pointerHighLightAnim.totalProgress(0.2);
        }
    }

    private setPickedPiesOnRestore() {
        /*third wheel on restore if landed index0*/
        for (let i = 0; i < this.levelPositionsTakenAfter.length; i++) {
            if (this.levelPositionsTakenAfter[i]) {
                if(this._pieSpriteContainers[this._index].getChildAt(i))  this._pieSpriteContainers[this._index].getChildAt(i).visible =true;
                this._pieContainers[this._index][i].getChildAt(0).alpha =0.6;
                this._betTextContainer.visible = true;
                this._betAccumulated.text = "X" + this.totalWheelTimesBetCollectedAfter.toString();
                this._betAccumulated.x = -this._betAccumulated.width / 2;
            } else {
                if(this._pieSpriteContainers[this._index].getChildAt(i))  this._pieSpriteContainers[this._index].getChildAt(i).visible =false;
                if(this.currentMode==ImmortalFruitsGameMode.BONUS_WHEEL && this.nextMode===ImmortalFruitsGameMode.BONUS_WHEEL){
                    this._betTextContainer.visible = true;
                }
            }
        }
    }
    private playFireWorks(){
        this.fireWorkSpriteArr.length=0;
        const childIndx =this._mainWheelContainer.getChildIndex(this.jackpotTextCont)+1;

        let tl =new TimelineLite();
        for(let i=0;i<8;i++){
            let fireWork = new TimelineSprite(GameResources.getTextures("fireWork"));
            fireWork.anchor.set(0.5);
            fireWork.visible =false;
            fireWork.blendMode =PIXI.BLEND_MODES.ADD;
            fireWork.position.set(-200+i*100,0);
            this.fireWorkSpriteArr.push(fireWork);
            this._mainWheelContainer.addChildAt(this.fireWorkSpriteArr[i],childIndx);
            if(i<5){
                tl.add(()=>{
                    fireWork.visible =true;
                    this.fireWorkSpriteArr[i].getAnimation([0],()=>{},()=>{
                        this.fireWorkSpriteArr[i].visible = false;
                    });
                },i*0.1);

            }

        }
        tl.add(()=>{
            this.playRandomlyFireWorks()
        },4*0.1+1);

    }
    /*
    * to calculate positions of fireworks
    * */
    private calculateFireworksPos(addX:number,addW:number,left:number){
      let  x= Math.floor(Math.random() * ( this._gameConfigInstance.REEL_AREA_POS_X +addX) ) +addW;
      let  y = Math.floor(Math.random() * (left*this._gameConfigInstance.REEL_AREA_HEIGHT/2 ))
        return {x,y}
    }
    /*
  * playing fireworks randomly animation during jackpot text scaling up
  * */
    private playRandomlyFireWorks() {
        let pos = {x: 0, y: 0};
        let tl = new TimelineLite()
        for (let index = 0; index < 8; index++) {
            tl.add(() => {
                if (index == 0) {
                    pos = this.calculateFireworksPos(100, 350, -1); //righttop
                } else if (index == 1 ) {
                    pos = this.calculateFireworksPos(-100, -350, -1);//Lefttop
                } else if (index == 2  || index==8) {
                    pos = this.calculateFireworksPos(100, 350, 1);//rightBottom

                } else if (index == 3 || index==7) {
                    pos = this.calculateFireworksPos(-100, -350, 1);//leftBottom
                } else if(index==4){
                    pos = this.calculateFireworksPos(100, 350, -1);
                }else if(index==5){
                    pos = this.calculateFireworksPos(-100, -350, -1);
                }
                this.fireWorkSpriteArr[index].visible = true;
                this.fireWorkSpriteArr[index].position.set(pos.x, pos.y);
                this.fireWorkSpriteArr[index].getAnimation([0], () => {
                }, () => {
                    this.fireWorkSpriteArr[index].visible = false;
                });
            }, index * 0.4);

        }

    }
    /*
 * playing animations on winning a multiplier or level
 * */
    private playWPresentation() {


        //let spineDuration = this.jackpotH.state.setAnimation(0, "mini_jp_hit_animation", false)
        this._wheelShadow.alpha = 0;
        let spineJackpotAnim = new TimelineLite();
        if (this.landedIndex === 0 && this._index !== 2) {
            this.stopInnerWheelTl();
            this.playLevelUpAnimation();
        } else {
            for (let i = 0; i < this.levelPositionsTakenAfter.length; i++) {
                if(this._index!==2 && i==0){
                    i++;
                }
                 if (this.highLightNumOnWheel(i)) {
                    if(this._pieSpriteContainers[this._index].getChildAt(i))  this._pieSpriteContainers[this._index].getChildAt(i).visible =true;
                     this._pieContainers[this._index][i].getChildAt(0).alpha =0.6;
                    this.showBetAccumulatedAnimation();


                    if ((this._jackpotIndicies == this.landedIndex && this.landedIndex === i)) {


                        this.bonusOverJackpot.renderable = true;
                        new SpineTween(this.bonusOverJackpot, 0, "bw_light_jp_hit_animation", -1);

                        this._darkBg.visible = false;
                        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELGLOWHIGHJACKPITHIT,undefined,1);
                        if(this.isPortrait){
                            this._starEmitterPortrait.emit =true;
                        }else {
                            this._starEmitter.emit = true;
                        }
                        freezeLayers.addBlur(this._layer);
                        spineJackpotAnim.add(() => {
                            this.jackpotH.renderable = true;
                            this.jackpotH.state.setAnimation(0, "mini_jp_hit_animation", false).timeScale=0.7;
                            if(ImmortalFruits.api.gameClientConfiguration.jurisdictionName!=="ES" && ImmortalFruits.api.gameClientConfiguration.jurisdictionName!=="LT" && ImmortalFruits.api.gameClientConfiguration.jurisdictionName!=="PT") { //#311
                                this.jackpotText.show();
                                this.jackPotAnimation = this.jackpotText.getAnimation();
                                this.jackPotAnimation.pause(0);
                                this.jackPotAnimation.play(0);
                                this.JackpotStatic.scale.set(0.85,0.85);
                                TweenLite.to(this.jackpotText,this.jackPotAnimation.totalDuration(),{alpha:1,onComplete:()=>{
                                        this.JackpotStatic.visible =true;
                                        this.jackpotText.visible =false;
                                        TweenLite.fromTo(this.JackpotStatic.scale,2.1,{x:0.85,y:0.85},{x:1.2,y:1.2,onComplete:()=>{
                                                this.JackpotStatic.visible =false;
                                                this.jackpotText.visible =true;
                                                this.jackPotAnimation.reverse(0);
                                                TweenLite.fromTo(this.jackpotText.scale,this.jackPotAnimation.totalDuration(),{x:2.3,y:2.3},{x:1.7,y:1.7});
                                            }
                                        });
                                    }});
                                this.jackPotAnimation.eventCallback("onReverseComplete",()=>{
                                    this.jackpotText.hide();
                                    this.jackpotH1.renderable = true;
                                    this.jackpotH1.state.setAnimation(0,"mini_jp_hit_center_animation",false);
                                });
                            }else{
                                this.jackpotH1.renderable = true;
                                this.jackpotH1.state.setAnimation(0,"mini_jp_hit_center_animation",false);
                            }
                                this._mainWheelContainer.addChildAt(this.bonusSpinLightAnim,this._mainWheelContainer.getChildIndex(this.borderWheel[2]));
                                this.bonusSpinLightAnim.renderable = true;
                                this.bonusSpinLightAnim.scale.set(1.5);
                                this.bonusSpinLightAnim.state.setAnimation(0, "bw_rw_spin_light_animation", true).timeScale=0.8;
                                this.redStroke.forEach((redStrokeAnim)=>{
                                    redStrokeAnim.playLoop();
                                    redStrokeAnim.visible = true;
                                })
                            //}


                            this.bonusRaysJackpot.renderable = true;
                            new SpineTween(this.bonusRaysJackpot, 0, "bw_rays_loop_animation", -1);

                        }, 0.2);
                        spineJackpotAnim.add(()=>{
                                this.playFireWorks();
                        },0.3);
                        spineJackpotAnim.add(() => {
                            this._darkBg.visible = true;
                            freezeLayers.removeBlur(this._layer);
                            EventHandler.dispatchEvent(new GameEvent(bonusWheelEvents.SHOW_JACKPOTWON));
                        }, 2);
                        spineJackpotAnim.add(() => {
                        }, spineJackpotAnim.totalDuration());
                    }


                }

            }


        }

    }
    /*
   * playing betMultiplier Animation
   * */
    private showBetAccumulatedAnimation() {

        this._betTextContainer.visible = true;
        this.multiplierMeter2.renderable = true;
        this.multiplierMeter.renderable = true;
        SoundManager.playSound(ImmortalFruitsSoundConfig.instance.BONUSWHEELMULTUPDATE,undefined,1);
        this.multiplierMeter.state.setAnimation(0, "jp_meter_animation", false);
        this.multiplierMeter2.state.setAnimation(0, "jp_meter_up_animation", false);
        this._betAccumulated.text = "X" + this.totalWheelTimesBetCollectedAfter.toString();
        this._betAccumulated.x = -this._betAccumulated.width / 2;
        TweenLite.fromTo(this._betAccumulated.scale, 0.5, {x: 1.2, y: 1.2}, {x: 1, y: 1})


    }
    /*
      * to check if number should be highlighted
      * */
    private highLightNumOnWheel(i: number) {
        return ((this.levelPositionsTakenAfter[i] && this.landedIndex == i) ||
            (this._jackpotIndicies == this.landedIndex && this.landedIndex == i
            && (this.nextMode === ImmortalFruitsGameMode.GAMBLE||this.nextMode===ImmortalFruitsGameMode.NORMAL)) || (this.landedIndex == 0 && this._index == 2 && i == 0)
            && (this._jackpotIndicies !== this.landedIndex && this.nextMode !== ImmortalFruitsGameMode.GAMBLE))


    }
    /*
  * to check if same pie is hit
  * */
    private isSamePieHit(i:number){

        return ((this.levelPositionsTakenAfter[i] && this.landedIndex == i &&
            i!==this._jackpotIndicies)&& this.nextMode === ImmortalFruitsGameMode.GAMBLE )
    }
    /*
* to create pies highlight sprites on each pie on all levels
* to be called once
* */
    private createPieSpriteContainers(index: number) {
        let pickedPiePos = -1.09;
        let rotatin = 0.31 - 0.02;

        for (let k = 0; k < this.numOfPieces; k++) {
            let tempSprite :Sprite;
            let pickedPierot = Math.round((this._coord * (k + 1) + Number.EPSILON) * 100) / 100 + pickedPiePos - 0.49;
            if (index == 0) {

                tempSprite =new Sprite(GameResources.getTextures("pickedPie")[0]);
                tempSprite.blendMode =PIXI.BLEND_MODES.MULTIPLY;
                tempSprite.name="pickedArr1"+k;
                this._pieSpriteContainers[0].addChild(tempSprite);
                tempSprite.rotation = Math.round((this._coord * (k + 1) + Number.EPSILON) * 100) / 100 + rotatin;
                tempSprite.scale.set(1.02, 1);
                tempSprite.position = this.rotPos(pickedPierot - 0.01, this._pickedDistance[index] + 2);

                if(k>1){
                    tempSprite.scale.set(1.02, 1);
                    tempSprite.position = this.rotPos(pickedPierot , this._pickedDistance[index] + 2);
                }
                if(k>0 && k<6){
                    tempSprite.scale.set(1.03, 1);
                }
                if(k==7){
                    tempSprite.scale.set(0.92, 1);
                    tempSprite.position = this.rotPos(pickedPierot + 0.03, this._pickedDistance[index] + 2);
                }
                tempSprite.visible = false;
            }


            if ( index == 1) {
                tempSprite =new Sprite(GameResources.getTextures("pickedPie")[0]);
                tempSprite.blendMode =PIXI.BLEND_MODES.MULTIPLY;
                tempSprite.name="pickedArr2"+k;
                this._pieSpriteContainers[1].addChild(tempSprite);
                tempSprite.rotation = Math.round((this._coord * (k + 1) + Number.EPSILON) * 100) / 100 + rotatin;
                if(k==7){
                    tempSprite.scale.set(0.92, 1);
                    tempSprite.position = this.rotPos(pickedPierot + 0.03, this._pickedDistance[index] + 2);
                }else{
                    tempSprite.scale.set(1, 1);
                    tempSprite.position = this.rotPos(pickedPierot , this._pickedDistance[index] );
                    tempSprite.rotation = Math.round((this._coord * (k + 1) + Number.EPSILON) * 100) / 100 + rotatin+0.02;
                }
                tempSprite.visible = false;
            }

            if (index == 2) {

                tempSprite =new Sprite(GameResources.getTextures("pickedPie")[0]);
                tempSprite.blendMode =PIXI.BLEND_MODES.MULTIPLY;
                tempSprite.name="pickedArr2"+k;
                this._pieSpriteContainers[2].addChild(tempSprite);

                tempSprite.rotation = Math.round((this._coord * (k + 1) + Number.EPSILON) * 100) / 100 + rotatin - 0.01+0.03;
                tempSprite.scale.set(1.07,1.05);
                tempSprite.position = this.rotPos(pickedPierot-0.01, this._pickedDistance[index] - 5);
                if(k<2){
                    tempSprite.scale.set(1.07,1.07);
                    tempSprite.position = this.rotPos(pickedPierot-0.02, this._pickedDistance[index] - 5);
                }
                if(k>1){
                    tempSprite.scale.set(1.08,1.07);
                }
                if(k==7){
                    tempSprite.scale.set(0.94, 1);
                    tempSprite.position = this.rotPos(pickedPierot + 0.03, this._pickedDistance[index] + 2);
                }
                if(k==9){
                    tempSprite.scale.set(1.05, 1.07);
                }
                tempSprite.visible = false;
            }
        }
    }

/*
* to calculate rot position of each number
* to be called once
* */
    private rotPos(rot: number, distance: number): PIXI.Point {
        return new PIXI.Point(distance * Math.cos(rot), distance * Math.sin(rot));
    }

    private addSlices(): void {
        for (var i = 0; i < this.numOfPieces; i++) {
            let textCont: PIXI.Container = new PIXI.Container();
            let textCont2: PIXI.Container = new PIXI.Container();
            let textCont3: PIXI.Container = new PIXI.Container();
            this._pieTextCont.push(textCont);
            this._pieTextCont2.push(textCont2);
            this._pieTextCont3.push(textCont3);
        }
        this._pieContainers[0] = this._pieTextCont;
        this._pieContainers[1] = this._pieTextCont2;
        this._pieContainers[2] = this._pieTextCont3;
    }


}